// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FLlx","toggle":"styles_toggle__2GRN7","preview":"styles_preview__3pO2f"};